import React, { useState } from 'react';
import { GatewayAccountDetailsModal } from './GatewayAccountDetailsModal';
import { GatewayAccountSearchModal } from './GatewayAccountSearchModal';

interface GatewayAccountLinkModalProps {
  onClose: () => void;
  accountId: string;
  paymentGatewayId: string;
}

export const GatewayAccountLinkModal: React.FC<
  GatewayAccountLinkModalProps
> = ({ onClose, accountId, paymentGatewayId }) => {
  const [gatewayCustomerId, setGatewayCustomerId] = useState<string>('');

  const handleCustomerFound = (foundGatewayCustomerId: string) => {
    setGatewayCustomerId(foundGatewayCustomerId);
  };

  if (gatewayCustomerId) {
    return (
      <GatewayAccountDetailsModal
        onClose={onClose}
        accountId={accountId}
        paymentGatewayId={paymentGatewayId}
        gatewayCustomerId={gatewayCustomerId}
      />
    );
  }

  return (
    <GatewayAccountSearchModal
      onClose={onClose}
      paymentGatewayId={paymentGatewayId}
      onCustomerFound={handleCustomerFound}
    />
  );
};
